/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */



//Disabout click
const noClickElements = document.querySelectorAll('.cursor-text');
const onClickHandler = (ev) => {
  ev.preventDefault(); ev.stopPropagation(); return false;
};
noClickElements.forEach(noClickElement => noClickElement.addEventListener('click', onClickHandler));

let textarea = document.querySelector('.gift_note_textarea');
let textareaCopy = document.querySelector('.gift-note-copy');
let current = document.querySelector('.gift_note_textarea_currentt');

if(textarea && textareaCopy && current) {
  textarea.addEventListener('keyup', function () {
    const characterCount = this.value.length;
    const max = textarea.getAttribute('maxlength');
    let remaning = max - characterCount;
    textareaCopy.value = textarea.value;
    current.textContent = remaning + " Characters Remaining";
  });
}

document.addEventListener('cart:rerendered', function(event) {
  textarea = document.querySelector('.gift_note_textarea');
  textareaCopy = document.querySelector('.gift-note-copy');
  current = document.querySelector('.gift_note_textarea_currentt');
  
  if(textarea && textareaCopy && current) {
    textarea.addEventListener('keyup', function () {
      const characterCount = this.value.length;
      const max = textarea.getAttribute('maxlength');
      let remaning = max - characterCount;
      textareaCopy.value = textarea.value;
      current.textContent = remaning + " Characters Remaining";
    });
  }
});

document.addEventListener('theme:collection:end', function (event) {

});

/* ------------------------------------------------------------------
 * Bridge PDP 'product:added' → #cart-drawer refresh.
 *
 * Why this exists:
 * PDP add-to-cart (theme.js) uses native fetch(/cart/add.js) and then
 * dispatches a 'product:added' CustomEvent. It does NOT fire CartJS's
 * 'cart.requestComplete' event, which is what script-free-gift.js
 * listens to in order to rebuild the cart drawer (including the
 * <additional-products> upsell element and its recommendation fetch).
 *
 * theme.js does TRY to refresh a '.mini-cart' element on product:added,
 * but this theme is a heavy Warehouse v4 fork that renders '#cart-drawer'
 * instead — '.mini-cart' doesn't exist, so that refresh silently fails
 * (TypeError inside a promise chain, never surfaced).
 *
 * The visible symptom: drawer upsells "lock" to whatever loaded at
 * initial page render, because the <additional-products> element is
 * never re-constructed on subsequent PDP adds.
 *
 * This bridge re-uses the exact refresh shape that the cart.requestComplete
 * handler in script-free-gift.js uses, but runs off product:added so
 * native-fetch adds are covered too.
 * ------------------------------------------------------------------ */
(function () {
  if (window.__pdpAddDrawerBridge) return;
  window.__pdpAddDrawerBridge = true;

  document.addEventListener('product:added', function () {
    fetch('/cart?section_id=api-cart-drawer')
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var drawer = document.querySelector('#cart-drawer');
        if (!drawer) return;
        var drawerInner = drawer.querySelector('.drawer__inner');
        if (!drawerInner) return;

        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var newInner = parsed.querySelector('.drawer__inner');
        if (!newInner) return;

        drawer.classList.remove('is-loading');
        // Replacing innerHTML re-upgrades custom elements inside, including
        // <additional-products>, which triggers a fresh recommendation fetch
        // keyed to the now-newest cart item.
        drawerInner.innerHTML = newInner.innerHTML;

        // Open the drawer only if it isn't already open. toggleCart() lives
        // in assets/mini-cart.js and is a global function.
        if (!drawer.classList.contains('is-drawer-open') && typeof toggleCart === 'function') {
          toggleCart();
        }
      })
      .catch(function () { /* intentional: leave drawer state as-is on network error */ });
  });
})();

/* ------------------------------------------------------------------
 * YouTube iframe facade — replaces ALL YouTube iframes (including
 * those pasted into product descriptions) with a click-to-play
 * thumbnail. Cancels in-flight YouTube downloads.
 * The brand-video section in sections/video.liquid renders its own
 * facade markup directly — this code handles iframes that ended up
 * in product descriptions or elsewhere.
 * ------------------------------------------------------------------ */
(function () {
  if (window.__ytFacade) return;
  window.__ytFacade = true;

  function extractId(src) {
    if (!src) return null;
    var m = src.match(/(?:embed\/|v=|youtu\.be\/)([\w-]{11})/);
    return m ? m[1] : null;
  }

  function buildFacade(iframe) {
    var id = extractId(iframe.getAttribute('src') || iframe.dataset.ytPending || '');
    if (!id) return;

    var width = parseInt(iframe.getAttribute('width'), 10) || 560;
    var height = parseInt(iframe.getAttribute('height'), 10) || 315;

    var wrap = document.createElement('div');
    wrap.className = 'yt-lazy-wrap';
    // Aspect ratio via padding-bottom % (more reliable than CSS aspect-ratio
    // when nested inside text containers / RTE descriptions).
    wrap.style.paddingBottom = (height / width * 100) + '%';
    wrap.style.maxWidth = width + 'px';

    var link = document.createElement('a');
    link.className = 'yt-lazy';
    link.href = 'https://www.youtube.com/watch?v=' + id;
    link.dataset.ytId = id;
    link.rel = 'noopener';
    link.setAttribute('aria-label', 'Play video');

    var img = document.createElement('img');
    img.src = 'https://img.youtube.com/vi/' + id + '/hqdefault.jpg';
    img.alt = '';
    img.loading = 'lazy';
    img.decoding = 'async';

    var play = document.createElement('span');
    play.className = 'yt-lazy__play';
    play.setAttribute('aria-hidden', 'true');

    link.appendChild(img);
    link.appendChild(play);
    wrap.appendChild(link);

    // Walk up the DOM and replace the outermost ancestor that contains ONLY
    // this iframe (with no other meaningful content). This handles cases where
    // the iframe is wrapped in extra containers like <p> or
    // <div class="video-wrapper"> (which has its own aspect-ratio padding —
    // leaving it in place would cause double padding and a tall empty area).
    var target = iframe;
    var parent = iframe.parentElement;
    while (parent && parent.tagName !== 'BODY' && parent.tagName !== 'HTML') {
      var clone = parent.cloneNode(true);
      var ifr = clone.querySelector('iframe');
      if (ifr) ifr.remove();
      // Stop if the parent has other meaningful content
      if (clone.textContent.trim() !== '') break;
      if (clone.querySelector('img, svg, video, audio, object, embed, canvas, a[href]')) break;
      // Otherwise climb one level up
      target = parent;
      parent = parent.parentElement;
    }
    target.replaceWith(wrap);
  }

  function isYouTubeIframe(node) {
    if (!node || node.nodeType !== 1 || node.tagName !== 'IFRAME') return false;
    // Skip iframes we just inserted via click handler — otherwise the MutationObserver
    // would see them as new YouTube iframes and immediately convert them back to facades.
    if (node.dataset && node.dataset.ytPlaying === '1') return false;
    var src = node.getAttribute('src') || '';
    return /youtube\.com\/embed|youtu\.be\//.test(src);
  }

  function processAll(root) {
    if (!root) return;
    if (isYouTubeIframe(root)) buildFacade(root);
    if (root.querySelectorAll) {
      root.querySelectorAll('iframe').forEach(function (f) {
        if (isYouTubeIframe(f)) buildFacade(f);
      });
    }
  }

  // Process iframes already in the DOM
  processAll(document.body);

  // Catch iframes added later (AJAX, dynamic content)
  if (window.MutationObserver) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(processAll);
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  // Click handler — load the real iframe with autoplay
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a.yt-lazy');
    if (!link) return;
    e.preventDefault();
    var id = link.dataset.ytId;
    if (!id) return;
    var iframe = document.createElement('iframe');
    // Mark before setting src so MutationObserver skips this iframe when it lands in the DOM.
    iframe.dataset.ytPlaying = '1';
    iframe.src = 'https://www.youtube.com/embed/' + id + '?autoplay=1&showinfo=0&controls=1&rel=0&modestbranding=1';
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('frameborder', '0');
    // Match the absolute positioning of the .yt-lazy link so the iframe fills
    // the wrap's padded box (wrap is height:0 + padding-bottom for aspect ratio).
    iframe.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;border:0;visibility:visible;';
    link.replaceWith(iframe);
  });
})();

/* ------------------------------------------------------------------
 * Featured Dynamic Collection — portrait video controls.
 * Replaces the per-section inline <script> that used to live in
 * sections/dynamic-featured-collection.liquid. One controller handles
 * N instances of the section on a page via event delegation + IO.
 *
 * Key behaviour:
 * - autoplay attribute is NOT set in the Liquid (changed to autoplay: false).
 *   This controller starts the video when it enters the viewport and pauses
 *   it when it leaves — so below-the-fold sections don't download their
 *   video until the user scrolls to them.
 * - User interaction (manual pause) is respected: we won't auto-resume on
 *   re-entry if the user paused it themselves.
 * - Honours prefers-reduced-motion: no autoplay, poster remains.
 * - MutationObserver picks up sections added via AJAX/section-rendering.
 * ------------------------------------------------------------------ */
(function () {
  if (window.__featuredVideoCtrl) return;
  window.__featuredVideoCtrl = true;

  var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function getVideoEl(featured) {
    var v = featured.querySelector('video.featured-video, .featured-video video, .featured-video');
    if (v && v.nodeName && v.nodeName.toLowerCase() === 'video') return v;
    var mv = featured.querySelector('media-video, media-cast, deferred-media');
    if (mv && mv.shadowRoot) {
      var sv = mv.shadowRoot.querySelector('video');
      if (sv) return sv;
    }
    return featured.querySelector('video');
  }

  function setPlayIcon(btn, isPlaying) {
    if (!btn) return;
    var playIcon = btn.querySelector('.is-play');
    var pauseIcon = btn.querySelector('.is-pause');
    if (!playIcon || !pauseIcon) return;
    playIcon.hidden = !!isPlaying;
    pauseIcon.hidden = !isPlaying;
    btn.setAttribute('aria-pressed', isPlaying ? 'true' : 'false');
    btn.setAttribute('aria-label', isPlaying ? 'Pause video' : 'Play video');
  }

  function setMuteIcon(btn, isMuted) {
    if (!btn) return;
    var unmutedIcon = btn.querySelector('.is-unmuted');
    var mutedIcon = btn.querySelector('.is-muted');
    if (!unmutedIcon || !mutedIcon) return;
    unmutedIcon.hidden = !!isMuted;
    mutedIcon.hidden = !isMuted;
    btn.setAttribute('aria-pressed', isMuted ? 'true' : 'false');
    btn.setAttribute('aria-label', isMuted ? 'Unmute video' : 'Mute video');
  }

  function tryPlay(video) {
    var p = video.play();
    if (p && typeof p.catch === 'function') p.catch(function () { /* autoplay blocked; poster remains */ });
  }

  function initFeatured(featured) {
    if (featured.__fvInit) return;
    featured.__fvInit = true;

    var video = getVideoEl(featured);
    var playBtn = featured.querySelector('.video-toggle[data-action="play"]');
    var muteBtn = featured.querySelector('.video-toggle[data-action="mute"]');
    if (!video || !playBtn || !muteBtn) return;

    // State: whether the user explicitly paused. If so, don't auto-resume on
    // scroll-back (annoying UX). Cleared when they hit play again.
    var userPaused = false;

    function syncIcons() {
      setPlayIcon(playBtn, !video.paused && !video.ended);
      setMuteIcon(muteBtn, video.muted);
    }

    if (video.readyState >= 1) syncIcons();
    else video.addEventListener('loadedmetadata', syncIcons, { once: true });

    video.addEventListener('play', function () { setPlayIcon(playBtn, true); });
    video.addEventListener('playing', function () { setPlayIcon(playBtn, true); });
    video.addEventListener('pause', function () { setPlayIcon(playBtn, false); });
    video.addEventListener('volumechange', function () { setMuteIcon(muteBtn, video.muted); });

    playBtn.addEventListener('click', function () {
      if (video.paused || video.ended) {
        userPaused = false;
        tryPlay(video);
      } else {
        userPaused = true;
        video.pause();
      }
    });

    muteBtn.addEventListener('click', function () {
      video.muted = !video.muted;
    });

    // Reduced-motion users never get autoplay. Poster stays; controls still work.
    if (prefersReducedMotion) return;

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            if (!userPaused && video.paused) tryPlay(video);
          } else {
            if (!video.paused) video.pause();
          }
        });
      }, { threshold: 0.25 });
      io.observe(featured);
    } else {
      // Very old browsers — just play immediately, forget the scroll pausing.
      tryPlay(video);
    }
  }

  function initAll(root) {
    (root || document).querySelectorAll('.featured-item[data-featured-id]').forEach(initFeatured);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  if (window.MutationObserver) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (!n || n.nodeType !== 1) return;
          if (n.matches && n.matches('.featured-item[data-featured-id]')) initFeatured(n);
          else if (n.querySelectorAll) initAll(n);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
})();

/* Judge.me Reviews Grid — inject "X ago" dates under each reviewer name.
   Judge.me's revamp grid widget doesn't render dates, and the app block
   offers no toggle. We fetch the same feed it uses (widgets/reviews_grid_widget_data),
   filter client-side to shop reviews (product_id == null), then match
   rendered cards to API reviews by reviewer name + review title to inject
   a "X hours/days/weeks/months ago" line below the name. */
(function () {
  function timeAgo(iso) {
    var d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    var secs = Math.max(1, Math.floor((Date.now() - d.getTime()) / 1000));
    var m = Math.floor(secs / 60);
    var h = Math.floor(m / 60);
    var days = Math.floor(h / 24);
    var weeks = Math.floor(days / 7);
    var months = Math.floor(days / 30);
    var years = Math.floor(days / 365);
    if (secs < 60) return 'just now';
    if (m < 60) return m + ' minute' + (m === 1 ? '' : 's') + ' ago';
    if (h < 24) return h + ' hour' + (h === 1 ? '' : 's') + ' ago';
    if (days < 7) return days + ' day' + (days === 1 ? '' : 's') + ' ago';
    if (weeks < 5) return weeks + ' week' + (weeks === 1 ? '' : 's') + ' ago';
    if (months < 12) return months + ' month' + (months === 1 ? '' : 's') + ' ago';
    return years + ' year' + (years === 1 ? '' : 's') + ' ago';
  }
  function decodeHtmlEntities(s) {
    var ta = document.createElement('textarea');
    ta.innerHTML = String(s || '');
    return ta.value;
  }
  function normalize(s) {
    return decodeHtmlEntities(s).trim().toLowerCase().replace(/\s+/g, ' ');
  }

  function injectDates(reviews) {
    var cards = document.querySelectorAll('.jdgm-reviews-grid-widget .jdgm-review-card');
    var byKey = {};
    reviews.forEach(function (r) {
      var key = normalize(r.reviewer_name) + '|' + normalize(r.title);
      if (!byKey[key]) byKey[key] = r;
    });
    cards.forEach(function (card) {
      if (card.querySelector('.dd-jdgm-date')) return; // already injected
      var name = card.querySelector('.jdgm-review-card__reviewer-name');
      var title = card.querySelector('.jdgm-review-card__details-title');
      if (!name || !title) return;
      var key = normalize(name.textContent) + '|' + normalize(title.textContent);
      var r = byKey[key];
      if (!r || !r.created_at) return;
      var span = document.createElement('span');
      span.className = 'dd-jdgm-date';
      span.textContent = timeAgo(r.created_at);
      // Append to the footer-inner (flex column) so date sits on its own
      // line below the name. The name-wrapper is a .jm-cluster with
      // flex-wrap: nowrap, which collapses any child to zero width.
      var footerInner = card.querySelector('.jdgm-review-card__footer-inner--details') ||
                        card.querySelector('.jdgm-review-card__footer-inner');
      if (footerInner) footerInner.appendChild(span);
    });
  }

  function fetchAndInject() {
    var grid = document.querySelector('.jdgm-reviews-grid-widget');
    if (!grid) return;
    var shopDomain = (window.Shopify && window.Shopify.shop) || location.hostname;
    // review_selection=store_reviews matches the grid's own data feed
    // (visible as data-review-selection on the widget root).
    var PER_PAGE = 50;
    function pageUrl(page) {
      return 'https://api.judge.me/widgets/reviews_grid_widget_data'
        + '?url=' + encodeURIComponent(shopDomain)
        + '&shop_domain=' + encodeURIComponent(shopDomain)
        + '&platform=shopify'
        + '&review_selection=store_reviews'
        + '&per_page=' + PER_PAGE
        + '&page=' + page;
    }

    var allReviews = [];
    // Page 1 first — gives us total_pages; then fetch the rest in parallel
    // so that "Show more" clicks can still match their newly-rendered cards.
    fetch(pageUrl(1)).then(function (r) { return r.json(); }).then(function (first) {
      allReviews = (first && first.reviews) || [];
      injectDates(allReviews);
      var totalPages = first && first.total_pages ? first.total_pages : 1;
      var rest = [];
      for (var p = 2; p <= totalPages; p++) {
        rest.push(fetch(pageUrl(p)).then(function (r) { return r.json(); }));
      }
      return Promise.all(rest);
    }).then(function (pages) {
      pages.forEach(function (j) { if (j && j.reviews) allReviews = allReviews.concat(j.reviews); });
      injectDates(allReviews);
      var gridBody = grid.querySelector('.jdgm-grid-body') || grid;
      if (window.MutationObserver) {
        new MutationObserver(function () { injectDates(allReviews); })
          .observe(gridBody, { childList: true, subtree: true });
      }
    }).catch(function () { /* swallow */ });
  }

  function waitForGrid(attempts) {
    attempts = attempts || 0;
    if (attempts > 40) return; // ~8s max wait
    var grid = document.querySelector('.jdgm-reviews-grid-widget .jdgm-review-card');
    if (grid) { fetchAndInject(); return; }
    setTimeout(function () { waitForGrid(attempts + 1); }, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { waitForGrid(); });
  } else {
    waitForGrid();
  }
})();

/* Judge.me all-reviews page widget — v3 loader bug workaround.
   `.jdgm-all-reviews-widget` never populates natively. We fetch separate
   product + store review streams from /widgets/reviews_grid_widget_data
   (confirmed: review_selection=product_reviews + review_selection=store_reviews),
   build two tabs matching the Judge.me editor layout, and render review
   HTML in the same .jdgm-rev shape the rest of the theme CSS targets.
   Each tab paginates independently via its own Load more button. */
(function () {
  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function formatDate(iso) {
    if (!iso) return '';
    var d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    var mm = String(d.getMonth() + 1).padStart(2, '0');
    var dd = String(d.getDate()).padStart(2, '0');
    return mm + '/' + dd + '/' + d.getFullYear();
  }
  function renderReview(r) {
    var rating = parseInt(r.rating, 10) || 0;
    var stars = '';
    for (var i = 1; i <= 5; i++) {
      stars += '<span class="jdgm-star jdgm--' + (i <= rating ? 'on' : 'off') + '"></span>';
    }
    var initial = (r.reviewer_initial || (r.reviewer_name || '?').charAt(0)).toUpperCase();
    var author = r.reviewer_name || '';
    var title = r.title ? '<b class="jdgm-rev__title">' + escapeHtml(r.title) + '</b>' : '';
    var productLine = '';
    if (r.product_id && r.product_title) {
      var href = r.product_url || ('/products/' + (r.product_handle || ''));
      productLine =
        '<div class="jdgm-rev__product-link">Review for ' +
          '<a href="' + escapeHtml(href) + '">' + escapeHtml(r.product_title) + '</a>' +
        '</div>';
    }
    return (
      '<div class="jdgm-rev jdgm-divider-top" data-review-id="' + escapeHtml(r.uuid) + '">' +
        '<div class="jdgm-rev__header">' +
          '<div class="jdgm-rev__icon">' + escapeHtml(initial) + '</div>' +
          '<div class="jdgm-rev__author-wrapper">' +
            '<span class="jdgm-rev__author">' + escapeHtml(author) + '</span>' +
            '<span class="jdgm-rev__timestamp">' + formatDate(r.created_at) + '</span>' +
          '</div>' +
          '<span class="jdgm-rev__rating" data-score="' + rating + '" aria-label="' + rating + ' star review" role="img">' + stars + '</span>' +
        '</div>' +
        '<div class="jdgm-rev__content">' +
          title +
          '<div class="jdgm-rev__body">' + (r.body_html || '') + '</div>' +
          productLine +
        '</div>' +
      '</div>'
    );
  }

  function init() {
    var widget = document.getElementById('judgeme_all_reviews_widget');
    if (!widget) return;
    if (widget.querySelector('.dd-jdgm-tab')) return; // already initialised

    var shopDomain = (window.Shopify && window.Shopify.shop) || location.hostname;
    var state = {
      product: { page: 0, totalPages: Infinity, total: 0, loading: false },
      store: { page: 0, totalPages: Infinity, total: 0, loading: false }
    };

    function pageUrl(tab, page) {
      var selection = tab === 'product' ? 'product_reviews' : 'store_reviews';
      return 'https://api.judge.me/widgets/reviews_grid_widget_data'
        + '?url=' + encodeURIComponent(shopDomain)
        + '&shop_domain=' + encodeURIComponent(shopDomain)
        + '&platform=shopify'
        + '&review_selection=' + selection
        + '&per_page=10'
        + '&page=' + page;
    }

    function fetchTabPage(tab, page) {
      return fetch(pageUrl(tab, page)).then(function (r) { return r.json(); });
    }

    // Fetch page 1 of both streams in parallel, then build the UI with counts.
    Promise.all([ fetchTabPage('product', 1), fetchTabPage('store', 1) ]).then(function (pages) {
      var p = pages[0] || {};
      var s = pages[1] || {};
      state.product.total = p.total_count || 0;
      state.product.totalPages = p.total_pages || 1;
      state.store.total = s.total_count || 0;
      state.store.totalPages = s.total_pages || 1;

      // Build shell
      widget.innerHTML = '';
      var tabs = document.createElement('div');
      tabs.className = 'dd-jdgm-tabs';
      tabs.innerHTML =
        '<button type="button" class="dd-jdgm-tab is-active" data-tab="product">Product reviews (' + state.product.total + ')</button>' +
        '<button type="button" class="dd-jdgm-tab" data-tab="store">Store reviews (' + state.store.total + ')</button>';
      widget.appendChild(tabs);

      ['product', 'store'].forEach(function (t) {
        var content = document.createElement('div');
        content.className = 'dd-jdgm-tab-content dd-jdgm-tab-content--' + t + (t === 'product' ? ' is-active' : '');
        widget.appendChild(content);
      });

      tabs.querySelectorAll('.dd-jdgm-tab').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var tab = btn.getAttribute('data-tab');
          tabs.querySelectorAll('.dd-jdgm-tab').forEach(function (t) {
            t.classList.toggle('is-active', t.getAttribute('data-tab') === tab);
          });
          widget.querySelectorAll('.dd-jdgm-tab-content').forEach(function (c) {
            c.classList.toggle('is-active', c.classList.contains('dd-jdgm-tab-content--' + tab));
          });
        });
      });

      // Render page 1 reviews into each tab
      state.product.page = 1;
      state.store.page = 1;
      renderAppend('product', p.reviews || []);
      renderAppend('store', s.reviews || []);
    });

    function renderAppend(tab, reviews) {
      var content = widget.querySelector('.dd-jdgm-tab-content--' + tab);
      if (!content) return;
      var oldBtn = content.querySelector('.dd-jdgm-all-reviews-more');
      if (oldBtn) oldBtn.remove();
      if (reviews.length) {
        content.insertAdjacentHTML('beforeend', reviews.map(renderReview).join(''));
      } else if (!content.querySelector('.jdgm-rev')) {
        content.innerHTML = '<p class="dd-jdgm-empty">No reviews yet.</p>';
      }
      if (state[tab].page < state[tab].totalPages) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'dd-jdgm-all-reviews-more jdgm-load-more-btn';
        btn.textContent = 'Load more reviews';
        btn.addEventListener('click', function () {
          if (state[tab].loading) return;
          state[tab].loading = true;
          btn.disabled = true;
          btn.textContent = 'Loading\u2026';
          fetchTabPage(tab, state[tab].page + 1).then(function (data) {
            state[tab].page += 1;
            renderAppend(tab, (data && data.reviews) || []);
            state[tab].loading = false;
          }).catch(function () {
            state[tab].loading = false;
            btn.disabled = false;
            btn.textContent = 'Load more reviews';
          });
        });
        content.appendChild(btn);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// DD-MARKER-1776999337 — all_reviews_fix push diagnostic
